import '../styles/academics.css'

const Academics = () => {
    return ( 
        <div className="academics-cont">
            <div className="academic-header-image"></div>
            <div className="academic-info">
                <span>At Acharya International ICSE School, we are dedicated to providing a comprehensive and enriching academic
                experience that prepares students for success in a rapidly evolving world. Our academic program is designed
                to foster critical thinking, creativity, and a lifelong love for learning. Here are some key aspects of academics
                at our school.</span>


                <p><span>ICSE Curriculum:</span> We follow the curriculum prescribed by the Indian Certificate of Secondary Education (ICSE) board, which
                provides a well-rounded education covering a wide range of subjects including English, Mathematics, Science, Social Studies,
                Languages, and Arts. This curriculum is recognized for its depth and rigor, ensuring that students develop a strong foundation
                in core academic areas.</p>


                <p><span>Experienced Faculty:</span> Our faculty members are highly qualified and experienced educators who are passionate about
                teaching and committed to the success of every student. They employ innovative teaching methodologies, differentiated
                instruction, and personalized attention to meet the diverse learning needs of our students.</p>

                <p><span>Holistic Approach:</span> In addition to academic subjects, we believe in the importance of holistic education. Our curriculum
                includes a focus on character development, leadership skills, moral values, and social responsibility. We integrate
                extracurricular activities, community service projects, and life skills education to nurture well-rounded individuals.</p>


                <p><span>Technology Integration:</span> We leverage technology as a tool to enhance teaching and learning. Our classrooms are
                equipped with interactive smart boards, multimedia resources, and access to digital learning platforms. We also offer
                computer science education to ensure that students are proficient in technology skills essential for the 21st century.</p>

                <p><span>Continuous Assessment:</span> We employ a variety of assessment methods including regular tests, quizzes, projects,
                presentations, and examinations to evaluate student progress and understanding. Continuous feedback is provided to
                students to support their academic growth and development.</p>

                <p><span>College Preparation:</span> We offer guidance and support to students as they prepare for higher education and career
                opportunities. This includes college counseling, assistance with standardized testing, resume building, interview preparation,
                and exploration of post-secondary pathways.</p>


                <p><span>Parental Involvement:</span> We recognize the importance of collaboration between school and parents in supporting student
                success. We encourage parental involvement through regular communication, parent-teacher meetings, workshops, and
                opportunities for parents to participate in school activities and events.</p>

                <p>Overall, academics at Acharya International ICSE School are designed to inspire intellectual curiosity, foster a spirit of inquiry,
                and empower students to become lifelong learners and responsible global citizens.</p>
            </div>
        </div>
     );
}
 
export default Academics;